import { chain, get, isEmpty, size, startCase } from 'lodash';
import React, { useState } from 'react';
import moment from 'moment';
import { makeStyles } from 'tss-react/mui';
import Button from '../ReusableComponents/Button/Button';
import TextInput from '../ReusableComponents/TextInput/TextInput';
import PurchaseOrderAPI from '../../Lib/Api/purchase-order';
import LoadingText from '../ReusableComponents/LoadingText/LoadingText';
import DetailField from '../ReusableComponents/DetailField/DetailField';

const useStyles = makeStyles()(() => ({
  root: {
    background: 'white',
    border: '12px solid black',
    borderRadius: '4px',
    display: 'flex',
    flexDirection: 'column',
    height: '600px',
    left: '100%',
    padding: '15px',
    position: 'absolute',
    top: '-10px',
    width: '165px',
  },
  button: {
    marginTop: '15px',
  },
  input: {
    marginTop: '25px',
  },
  detail: {
    maxWidth: '165px',
  },
  error: {
    color: `rgba(0, 0, 0, 0.38)`,
    fontSize: '12px',
    fontWeight: 'bold',
    lineHeight: '1.57',
    letterSpacing: 'normal',
    marginTop: '25px',
    maxWidth: '165px',
    minHeight: '22px',
    textTransform: 'uppercase',
  },
}));

export default function QuickOrderSearch() {
  const { classes } = useStyles();
  const [poNumber, setPONumber] = useState('');
  const [order, setOrder] = useState(null);
  const [error, setError] = useState(null);
  const [searching, setSearching] = useState(false);

  const searchPO = () => {
    if (isEmpty(poNumber)) return;

    setSearching(true);
    PurchaseOrderAPI.findOneByPONumber(poNumber)
      .then(({ purchaseOrder }) => {
        console.log(purchaseOrder);
        setSearching(false);
        setError(null);
        setOrder(purchaseOrder);
      })
      .catch((err) => {
        console.log(err);
        setSearching(false);
        setOrder(null);
        setError(err);
      });
  };

  const topItems = chain(order)
    .get('items')
    .filter((item) => item.quantity > 0)
    .value();

  const topStatuses = chain(topItems)
    .map((item) =>
      item.top_status ? `${startCase(item.top_status)} - ${item.size}` : null,
    )
    .compact()
    .uniq()
    .value();

  const delivery = get(order, 'delivery');
  const booking = get(delivery, 'booking');
  const deliveryLocation = get(booking, 'location.name');

  return (
    <div className={classes.root}>
      <TextInput
        className={classes.input}
        label="PO Number"
        value={poNumber}
        onChange={({ target: { value } }) => {
          setError(null);
          setPONumber(value);
        }}
      />
      <Button
        className={classes.button}
        onClick={searchPO}
        variant="outlined"
        color="primary"
        small
      >
        {searching ? <LoadingText text="Searching" /> : 'Search'}
      </Button>

      {error && (
        <div className={classes.error}>
          {`Purchase order number ${poNumber} was not found, please make sure you
          have entered the number correctly`}
        </div>
      )}

      {!searching && !error && order && (
        <div>
          <DetailField minWidth="50px" label="Due Date">
            <span>{moment.utc(order.due_date).format('L')}</span>
          </DetailField>
          <DetailField minWidth="50px" label="TOP Due Date">
            <span>{moment.utc(order.top_due_date).format('L')}</span>
          </DetailField>
          <DetailField minWidth="50px" label="Original Due Date">
            <span>{moment.utc(order.original_due_date).format('L')}</span>
          </DetailField>
          <DetailField minWidth="50px" label="Buyer Name">
            <span>{order.buyer_name}</span>
          </DetailField>
          {size(topStatuses) && (
            <div className={classes.detail}>
              <DetailField minWidth="50px" label="Top Status">
                <div>
                  {topStatuses.map((status) => (
                    <div key={status}>{status}</div>
                  ))}
                </div>
              </DetailField>
            </div>
          )}
          <DetailField label={delivery ? 'Delivery On' : 'Delivery Status'}>
            <span>
              {delivery
                ? moment.utc(booking.starts_at).format('llll')
                : 'Not Scheduled'}
            </span>
          </DetailField>
          {delivery && (
            <DetailField label="Delivery Location">
              <span>{startCase(deliveryLocation)}</span>
            </DetailField>
          )}
        </div>
      )}
    </div>
  );
}
